var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconHeartFilledM(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 32a1 1 0 01-.55-.17C6.71 23.41 6.93 16.27 7 15.38 7 11.17 10 8 14 8c2.76 0 4.85 1 6 2.73C21.15 9 23.24 8 26 8c4 0 7 3.17 7 7.38.09.89.31 8-12.43 16.45A1 1 0 0120 32zm13-16.57z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h40v40H0z"
  })));
}

export default SvgIconHeartFilledM;